var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.model.cobroexpress)?_c('CobroFacturasCE'):_vm._e(),(_vm.model.rapipago)?_c('CobroFacturasRP'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }